import React, {useMemo, useState} from "react";
import "./index.scss";
import Button from "features/components/button";
import {__} from "services/i18n";
import {HELP_EMAIL} from "constants.js";
import osaLogo from "images/logo/colored.svg";
import Text from "features/components/text";
import Title from "features/components/title";
import {TextField} from "features/components/text-field";
import {Icon} from "features/components/icon";
import {ciCompare} from "services/utils/utils";
import {groupBy} from "lodash";
import {HelpItem} from "features/pages/help/help-item";
import {connect} from "react-redux";
import {startFaqGet} from "features/pages/help/reducer";
import {faqData, faqErrorSelector, faqLoading} from "features/pages/help/selectors";
import {LoadingLogoPortal} from "features/components/loading-logo";
import {historyObject} from "historyObject";

/* istanbul ignore next */
const mapStateToProps = state => ({
    data: faqData(state),
    loading: faqLoading(state),
    error: faqErrorSelector(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    startFaqGet
};

export const PageHelp = (props) => {

    const [search, setSearch] = useState("");

    const {startFaqGet, data, loading, error} = props;

    React.useEffect(() => {
        startFaqGet();
    }, [startFaqGet]);

    const questions = useMemo(() => {
        if(search.length < 3) {
            return data.faqs;
        }
        return data.faqs.filter(i => {
            return ciCompare(i.text, search) || ciCompare(i.title, search) || ciCompare(i.argument, search);
        })
    }, [search, data]);

    const questionsGrouped = useMemo(() => {
        const grouped = groupBy(questions, i => i.argument);
        return Object.entries(grouped).map(([key, value]) => ({argument: key, list: value}));
    }, [questions]);

    if(loading) {
        return <LoadingLogoPortal />
    }

    return <div className="page-help">
        <div className="header">
            <div className="logo">
                <img onClick={() => historyObject.push("/")} src={osaLogo} alt={"osa logo"} />
                <span className="separator" />
                <Text size={18}>{__("helpcenter.menu-title")}</Text>
            </div>
            <Button title={__("buttons.send-us-email")} onClick={() => window.open(`mailto:${HELP_EMAIL}`)} />
        </div>
        <div className="search">
            <div className="search-content">
                <Title size={34} align={"center"}>{__("helpcenter.title")}</Title>
                <Text size={16} align={"center"}>{__("helpcenter.text")}</Text>
                <div className="field">
                    <Icon>search</Icon>
                    <TextField type={"text"} value={search} onChange={setSearch} placeholder={__("helpcenter.placeholder")} backgroundWhite={true} />
                    <div className={`reset ${search !== "" ? "show" : ""}`} onClick={() => setSearch("")}>
                        <Icon>close</Icon>
                    </div>
                </div>
            </div>
        </div>
        <div className="results">
            {error.inError && <Text size={16} color={"danger"}>{__(error.error)}</Text>}
            {questionsGrouped.length === 0 && <Text size={16} align={"center"}>{__("helpcenter.no-results")}</Text>}
            {questionsGrouped.map(obj => <div className="argument" key={obj.argument}>
                <Title size={18}>{obj.argument}</Title>
                {obj.list.map(item => <HelpItem key={item.title} {...item} />)}
            </div>)}
        </div>
    </div>
}
export default connect(mapStateToProps, mapDispatchToProps)(PageHelp);